const ScrollView = ({
  children,
  style,
  className,
  nodeRef,
  scrollbarWidth,
}) => (
  <div
    style={{
      ...style,
      marginRight: -scrollbarWidth,
    }}
    className={className}
    ref={nodeRef}
  >
    {children}
  </div>
);

ScrollView.defaultProps = {
  style: {
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
  className: 'view',
};

export default ScrollView;
